import { render } from "./ElektroAgregati.vue?vue&type=template&id=4dc896f0&scoped=true"
import script from "./ElektroAgregati.vue?vue&type=script&lang=js"
export * from "./ElektroAgregati.vue?vue&type=script&lang=js"

import "./ElektroAgregati.vue?vue&type=style&index=0&id=4dc896f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc896f0"]])

export default __exports__